import { render, staticRenderFns } from "./DicMsgManagement.vue?vue&type=template&id=11460bfe&"
import script from "./DicMsgManagement.vue?vue&type=script&lang=js&"
export * from "./DicMsgManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports